import React from "react";
import { useQuery } from "@apollo/client";
import { GET_CITIES, GET_REGIONS } from "../../utils/api/campaign";
import {Button, Col, Row, Select} from "antd";
import {Controller, useFieldArray, useFormContext} from 'react-hook-form';
import {DeleteOutlined, MinusOutlined, PlusOutlined} from "@ant-design/icons";
import { SizeType } from "antd/es/config-provider/SizeContext";

const countryCode = 'DK'
interface LocationTargetingProps {
  name: string,
}

interface CityPickerProps {
  region: string
  value: any,
  onChange: any,
  className: string,
  size: SizeType
}

const CityPicker: React.FC<CityPickerProps> = ({region, onChange, value = [], ...props}) => {
  const {data: citiesData} = useQuery(GET_CITIES, {
    variables: {
      countryCode, region
    },
    skip: !region
  })

  if (!region) {
    return null
  }

  const {cities: cityOptions = []} = citiesData || {}

  return <Select
    {...props}
    options={cityOptions}
    placeholder="Select a city"
    value={value.cities}
    showSearch
    optionFilterProp='label'
    mode="multiple"
    onChange={(newCities: string[]) => onChange({...value, cities: newCities})}
  />
}
const SearchMultiSelect: React.FC<LocationTargetingProps> = ({name}) => {
  const form = useFormContext();

const {fields, append, remove} = useFieldArray({name})

  const {data: regionsData} = useQuery(GET_REGIONS, {variables: {
    countryCode
  }})

  const {regions: regionOptions = []} = regionsData || {}

  const value = form.watch(name)

  const checked = !!value && value.length > 0
  const handleChange = () => {
    if (checked) {
      form.setValue(name, [], {shouldDirty: true})
    }
  }

  return (
    <Row>
      <Col span={8}>
        <label className="flex items-center text-sm font-medium text-gray-700">
          <Button type="link" icon={<DeleteOutlined />} onClick={handleChange} danger disabled={!checked} />
          Targeting Locations
        </label>
      </Col>
      <Col span={16}>
          {fields.map((item, index) => (
                <Row className='mb-3' key={item.id}>
                  <Controller
                    control={form.control}
                    name={`${name}.${index}`}
                    render={({field: {onChange, value}}) => (
                      <>
                        <Select className="w-[320px]" size='large' options={regionOptions} value={value?.region} placeholder="Select a region" onChange={(region) => onChange({region, countryCode})}/>
                        <CityPicker className='w-[320px] ml-3' size='large' region={value?.region} value={value} onChange={onChange}/>
                      </>
                    )}
                  />
                  <Button className='ml-3 h-[38px] !w-[38px]' icon={<MinusOutlined />} onClick={() => remove(index)} />
                </Row>
          ))}
               <Button
          className='!w-[320px] h-[38px]'
          icon={<PlusOutlined />}
          onClick={() =>append({countryCode})}
        >Add location targeting</Button>
      </Col>
    </Row>
  );
};

export default SearchMultiSelect;
